"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorStack = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ui_1 = require("@grafana/ui");
const EditorStack = (_a) => {
    var _b, _c;
    var { children, wrap: wrapItems = true } = _a, props = tslib_1.__rest(_a, ["children", "wrap"]);
    return (react_1.default.createElement(ui_1.Stack, Object.assign({ wrap: wrapItems ? 'wrap' : undefined, direction: (_b = props.direction) !== null && _b !== void 0 ? _b : 'row', gap: (_c = props.gap) !== null && _c !== void 0 ? _c : 2 }, props), children));
};
exports.EditorStack = EditorStack;
//# sourceMappingURL=EditorStack.js.map